import React from "react";

export default function StatusDetailsModal({ show, onClose, item }) {
  if (!show || !item) return null;

  const formatDate = (date) =>
    date ? date.substring(0, 10) : "-";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        zIndex: 999,
      }}
    >
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "480px",
          background: "#fff",
          padding: "20px",
          borderRadius: "8px",
          zIndex: 1000,
        }}
      >
        <h5 className="mb-3 text-center">
          {item.status} Details
        </h5>

        {/* COMMON FIELDS */}
        <div className="mb-2">
          <label className="form-label fw-semibold">Project</label>
          <input className="form-control" value={item.projectName || "-"} disabled />
        </div>

        <div className="mb-2">
          <label className="form-label fw-semibold">Vehicle Type</label>
          <input className="form-control" value={item.vehicleType || "-"} disabled />
        </div>

        <div className="mb-2">
          <label className="form-label fw-semibold">Requested Date</label>
          <input className="form-control" value={formatDate(item.requestedDate)} disabled />
        </div>

        {/* APPROVED */}
        {item.status === "Approved" && (
          <>
            <div className="mb-2">
              <label className="form-label fw-semibold">Approved By</label>
              <input className="form-control" value={item.approvedBy || "-"} disabled />
            </div>

            <div className="mb-2">
              <label className="form-label fw-semibold">Approved Date</label>
              <input className="form-control" value={formatDate(item.approvedDate)} disabled />
            </div>

            <div className="mb-2">
              <label className="form-label fw-semibold">Assigned Vehicle</label>
              <input className="form-control" value={item.vehicleId || "-"} disabled />
            </div>

            <div className="mb-2">
              <label className="form-label fw-semibold">Approval Notes</label>
              <textarea className="form-control" value={item.approvedNotes || "-"} disabled />
            </div>
          </>
        )}

        {/* REJECTED */}
        {item.status === "Rejected" && (
          <>
            <div className="mb-2">
              <label className="form-label fw-semibold">Rejected By</label>
              <input className="form-control" value={item.rejectedBy || "-"} disabled />
            </div>

            <div className="mb-2">
              <label className="form-label fw-semibold">Rejected Date</label>
              <input className="form-control" value={formatDate(item.rejectedDate)} disabled />
            </div>

            <div className="mb-2">
              <label className="form-label fw-semibold">Rejection Note</label>
              <textarea className="form-control" value={item.rejectedNotes || "-"} disabled />
            </div>
          </>
        )}

        {/* ESCALATED */}
        {item.status === "Escalated" && (
          <>
            <div className="mb-2">
              <label className="form-label fw-semibold">Escalated By</label>
              <input className="form-control" value={item.escalatedBy || "-"} disabled />
            </div>

            <div className="mb-2">
              <label className="form-label fw-semibold">Escalated Date</label>
              <input className="form-control" value={formatDate(item.escalatedDate)} disabled />
            </div>

            <div className="mb-2">
              <label className="form-label fw-semibold">Escalation Note</label>
              <textarea className="form-control" value={item.escalatedNotes || "-"} disabled />
            </div>
          </>
        )}

        {/* CLOSE */}
        <div className="text-end">
          <button className="btn btn-secondary mt-2" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
